import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class ScreenDimmer extends PIXI.Container {
    private _dimmer: PIXI.Sprite;

    constructor() {
        super();
        this.name = "ScreenDimmer";

        this.init();
        this.onResize();
    }

    private createDimmer(): PIXI.Sprite {
        const dimmer: PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        dimmer.name = "dimmer";
        dimmer.width = 720;
        dimmer.height = 720;
        dimmer.position.set(360, 360);
        dimmer.anchor.set(0.5, 0.5);
        dimmer.tint = 0x000000;
        dimmer.alpha = 0.8;
        this.addChild(dimmer);
        return dimmer;
    }

    private init(): void {
        this._dimmer = this.createDimmer();
        this.visible = false;
    }

    public show(): void {
        this._dimmer.alpha = 0;
        this.visible = true;
        this.onResize();
    }
    public hide(): void {
        this.visible = false;
    }

    public fadeIn(alpha:number = 0.7): gsap.core.Timeline {
        return gsap.timeline().to(this._dimmer, 0.2, {alpha:alpha});
    }
    public fadeOut(): gsap.core.Timeline {
        return gsap.timeline().to(this._dimmer, 0.2, {alpha:0});
    }
    public onResize(): void {
        if(this._dimmer && this.visible){
            this._dimmer.width = NolimitApplication.screenBounds.width;
            this._dimmer.height = NolimitApplication.screenBounds.height;
        }
    }
}